import { Box, Typography, IconButton } from "@mui/material";
import styled from "@mui/material/styles/styled";

export const CarouselHeader = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "16px",
  marginBottom: "0",
});

export const HeaderText = styled(Typography)({
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "22px",
  letterSpacing: "0%",
  textAlign: "center",
  color: "#1f2937",
});

export const ArrowButton = styled(IconButton)({
  fontSize: "18px",
  fontWeight: 600,
  color: "#000000",
  transition: "all 0.2s ease",
  position: "relative",
  top: "1px",
  "&:hover": {
    backgroundColor: "transparent",
    color: "#9ca3af",
  },
});

export const CarouselContainer = styled(Box)({
  width: "100%",
  height: "670px",
  overflow: "hidden",
  position: "relative",
  // Create a stacking context and keep it below header/app bar
  zIndex: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: "0",
  paddingBottom: "16px",
  backgroundColor: "#FFFFFF",
  backgroundImage: "none",

  // Side fades, match theme background color
  "&::before, &::after": {
    content: '""',
    position: "absolute",
    top: 0,
    bottom: 0,
    width: "60px",
    zIndex: 2,
    pointerEvents: "none",
  },

  "&::before": {
    left: 0,
    background:
      "linear-gradient(to right, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%)",
  },

  "&::after": {
    right: 0,
    background:
      "linear-gradient(to left, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%)",
  },
});

export const CarouselTrack = styled(Box)({
  position: "relative",
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const MaterialThumbnail = styled(Box)({
  width: "273px",
  height: "421px",
  borderRadius: "16px",
  position: "relative",
  cursor: "pointer",
  transition: "transform 0.3s ease",
  overflow: "visible",
  willChange: "transform, opacity",
  transformOrigin: "50% 50%",
  backgroundColor: "#FFFFFF",
  "& .card-inner": {
    position: "relative",
    width: "100%",
    height: "100%",
  },
  "& .card-face": {
    position: "absolute",
    inset: 0,
    borderRadius: "16px",
    transition: "opacity 0.8s ease",
    opacity: 0,
  },
  "& .card-front": {
    opacity: 1,
  },
  "&:hover .card-front": {
    opacity: 0,
  },
  "&:hover .card-back": {
    opacity: 1,
  },
});

export const ExpandedOverlay = styled(Box)({
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0, 0, 0, 0.45)",
  zIndex: 9999,
});

export const ExpandedCard = styled(Box)({
  position: "fixed",
  left: 0,
  top: 0,
  willChange: "transform",
  zIndex: 10000,
  borderRadius: "16px",
  overflow: "visible",
});

export const PreviewOverlay = styled("button")({
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0, 0, 0, 0.75)",
  zIndex: 10001,
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  cursor: "pointer",
  transition: "opacity 0.3s ease",
  overflowY: "auto",
  padding: "20px",
  boxSizing: "border-box",
  border: "none",
  outline: "none",
  width: "100%",
  height: "100%",
});

export const PreviewImage = styled(Box)({
  maxWidth: "90vw",
  width: "auto",
  margin: "auto",
  borderRadius: "16px",
  overflow: "hidden",
  boxShadow: "0 20px 60px rgba(0, 0, 0, 0.5)",
  cursor: "default",
  marginTop: "20px",
  marginBottom: "20px",
  position: "relative",
  "& img": {
    width: "100%",
    height: "auto",
    maxWidth: "100%",
    objectFit: "contain",
    display: "block",
  },
});

export const PreviewCloseButton = styled(IconButton)({
  position: "absolute",
  top: "12px",
  right: "12px",
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  color: "#000000",
  width: "40px",
  height: "40px",
  zIndex: 10,
  "&:hover": {
    backgroundColor: "#FFFFFF",
  },
  "& svg": {
    width: "24px",
    height: "24px",
  },
});
